(function () {
  function normalizeFit(text) {
    var t = String(text || '')
      .toLowerCase()
      .replace(/['’]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!t) return '';
    if (t.indexOf('custom relaxed') !== -1) return 'Custom Relaxed Fit';
    if (t.indexOf('standard fit') !== -1) return 'Standard Fit';
    if (t.indexOf('classic fit') !== -1) return 'Standard Fit';
    if (t.indexOf('custom fit') !== -1) return 'Custom Fit';
    if (t.indexOf('relaxed fit') !== -1) return 'Relaxed Fit';
    return '';
  }

  function cardFit(card) {
    if (!card) return '';
    var labelled = (card.getAttribute('data-fit') || '').trim();
    if (labelled) return labelled;
    return (
      normalizeFit(card.getAttribute('data-fit-notes') || '') ||
      normalizeFit(card.getAttribute('data-title') || '') ||
      normalizeFit(card.getAttribute('data-tags') || '')
    );
  }

  function cardMatchesFit(card, fit) {
    if (!fit) return true;
    return cardFit(card) === fit;
  }

  function getGrid() {
    return document.querySelector('[class*="ai-product-grid-"]');
  }

  function patchGrid(grid) {
    if (!grid || grid._hwFitPatched) return grid;
    if (typeof grid.applyFiltersAndSort !== 'function') return grid;

    grid._hwFitPatched = true;
    if (!grid.activeFilters) grid.activeFilters = {};
    var original = grid.applyFiltersAndSort.bind(grid);

    grid.applyFiltersAndSort = function (options) {
      original(options);
      var fit = (this.activeFilters && this.activeFilters.fit) || '';
      if (!fit) return;
      var source = this.filteredCards && this.filteredCards.length ? this.filteredCards : this.productCards || [];
      this.filteredCards = source.filter(function (card) {
        return cardMatchesFit(card, fit);
      });
      if (!options || options.resetPage !== false) this.currentPage = 1;
      if (typeof this.updateDisplay === 'function') this.updateDisplay();
    };

    return grid;
  }

  function applyFit(fit) {
    var grid = patchGrid(getGrid());
    if (!grid) return;
    if (!grid.activeFilters) grid.activeFilters = {};
    grid.activeFilters.fit = fit || '';
    grid.currentPage = 1;
    if (typeof grid.applyFiltersAndSort === 'function') {
      grid.applyFiltersAndSort();
    }
  }

  function scrollToGrid() {
    var grid = getGrid();
    if (!grid) return;
    var top = grid.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0) - 80;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  window.hwCasualFit = {
    normalizeFit: normalizeFit,
    cardFit: cardFit,
    cardMatchesFit: cardMatchesFit,
    applyFit: applyFit,
    patchGrid: patchGrid,
    scrollToGrid: scrollToGrid
  };

  document.addEventListener('hw-casual-fit-change', function (event) {
    applyFit((event.detail && event.detail.fit) || '');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchGrid(getGrid());
    });
  } else {
    patchGrid(getGrid());
  }
})();
